import * as React from 'react';

import FileXdw32 from './FileXdw32';

export const fileXdw32 = () => <FileXdw32 />;

export default {
    title: 'Icon/Content/FileXdw32',
    component: FileXdw32,
    parameters: {
        notes: "`import FileXdw32 from 'box-ui-elements/es/icon/content/FileXdw32';`",
    },
};
